import * as React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import * as WebFont from 'webfontloader';

import { withMedia, WithMediaProps, styledWithProps } from '../util/styles';
import colors from './colors';
import ConvoWrapperContainer from './Conversation/ConvoWrapperContainer';
import CtaContainer from './Cta/CtaContainer';
import ProactiveContainer from './Proactive/ProactiveContainer';
import LeaveMessageContainer from './LeaveMessage/LeaveMessageContainer';

let theme: any;

interface Props extends WithMediaProps {
    showMessagePanel: boolean;
    showCta: boolean;
    showLeaveMessagePanel: boolean;
    isBootstrapped: boolean;
    messageListType: string;
    hidden: boolean;
    zIndex: string;
}

interface State {
    font: string;
}

class App extends React.Component<Props, State> {
    state = { font: 'Montserrat' };

    constructor(props: Props) {
        super(props);
    }

    componentDidMount() {
        this.loadFont();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.messageListType !== this.props.messageListType) {
            this.loadFont();
        }
    }

    loadFont() {
        if (!this.props.messageListType) return;

        let font = this.state.font;
        switch (this.props.messageListType) {
            case 'cars.com':
                font = 'Source Sans Pro';
                break;
            default:
                break;
        }

        this.setState({ font }, () => {
            WebFont.load({
                google: {
                    families: [`${this.state.font}:200,300,300i,400,400i,500,700`],
                },
            });
        });
    }

    render() {
        const {
            messageListType,
            isBootstrapped,
            showMessagePanel,
            isMobile,
            showCta,
            hidden,
            showLeaveMessagePanel,
        } = this.props;

        if (!isBootstrapped || hidden) return null;

        let bubbleMarginBottom = '15px';
        if (isMobile) bubbleMarginBottom = '10px';

        theme = {
            messageBubble: {
                agent: {
                    bgColor:
                        messageListType !== 'cars.com'
                            ? colors.mediumLightGray
                            : colors.carsLightBlue,
                    fgColor: colors.extraDarkGray,
                },
                visitor: {
                    bgColor: messageListType !== 'cars.com' ? colors.blue : colors.carsDarkBlue,
                    fgColor: colors.white,
                },
                marginBottom: bubbleMarginBottom,
            },
            warningButton: {
                bgColor: colors.white,
                fgColor: messageListType !== 'cars.com' ? '#acacac' : colors.carsLightPurple,
                primaryBgColor:
                    messageListType !== 'cars.com' ? colors.red : colors.carsLightPurple,
                primaryFgColor: colors.white,
            },
            fontWeight: messageListType !== 'cars.com' ? 300 : 400,
        };

        return (
            <AppWrapper className="conversations-root" font={this.state.font} zIndex={this.props.zIndex}>
                <ThemeProvider theme={theme}>
                    {showMessagePanel && <ConvoWrapperContainer />}
                </ThemeProvider>
                {showCta && <ProactiveContainer />}
                {showCta && <CtaContainer />}
                {showLeaveMessagePanel && <LeaveMessageContainer />}
            </AppWrapper>
        );
    }
}

type AppWrapperProps = {
    font: string;
    zIndex: string;
};

const AppWrapper = styledWithProps<AppWrapperProps>(styled.div)`
    & * {
        box-sizing: border-box;
    }
    font-family: '${props => props.font}', sans-serif;
    color: ${colors.extraDarkGray};
    font-size: 14px;
    line-height: 1.3;

    position: relative;
    z-index: ${props => props.zIndex};
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: ${colors.blue};
        margin: 0;
        font-weight: 500;
        text-transform: none;
    }
    h1 {
        font-size: 22px;
        line-height: 1;
        letter-spacing: 0;
    }
    h3 {
        font-size: 16px;
        line-height: 1;
        letter-spacing: 0;
    }
`;

export default withMedia(App);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/App.tsx